// Mantine color for a match / coverage percentage. Shared by every surface that
// shows a "% match" so the thresholds stay in one place.
export const matchColor = (pct: number): string =>
    pct >= 70 ? 'teal' : pct >= 50 ? 'yellow' : 'red'
